import React from 'react'
import { View } from 'react-native'
import { useMatrixUser } from '@vatom/sdk/react'

import { isCurrentUserJoined } from '../helpers'
import { useMembers } from '../queries'

const IsUserJoinedWrapper = (props: any) => {
  const { roomId, children } = props
  const { data: matrixUser } = useMatrixUser()
  const { data: roomMembers } = useMembers(roomId)

  const isUserJoined = isCurrentUserJoined(roomMembers, matrixUser?.user_id)

  return <View style={{ marginTop: 20, overflow: 'hidden' }}>{isUserJoined ? children : null}</View>
}

export default IsUserJoinedWrapper
